<lib-dynamic-listing
  [data]="tableData"
  [columns]="columnConfigs"
  [filters]="filterConfigs"
  [actions]="actionConfigs"
  [headerActions]="headerActionConfigs"
  [isLoading]="isLoading"
  [pageIndex]="pageIndex"
  [rowsPerPage]="rowsPerPage"
  [totalCount]="totalCount"
  [totalPages]="totalPages"
  [exportFilename]="exportFilename"
  (filterEvent)="onFilterEvent($event)"
  (columnsSelected)="onColumnsSelected($event)"
  (actionClicked)="onActionClicked($event)"
  (pageChanged)="onPageChanged($event)"
  (exportCsv)="exportCsv()"
  (exportXlsx)="exportXlsx()"
  (exportPdf)="exportPdf()">
</lib-dynamic-listing>
